<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const user = computed(() => store.getters.getUserDetails);

const userRole = computed(() => {
    const attributes = user.value;
    
    if (!Array.isArray(attributes)) {
        return null; 
    }
    
    const roleAttr = attributes.find(attr => attr.Name === 'custom:role');
    
    return roleAttr ? roleAttr.Value : null;
});

</script>
<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="['admin','issuer','purchase'].includes(userRole)?items:null" />

        <!-- /product list -->
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-set">
                <div class="search-path">
                  <a
                    class="btn btn-filter"
                    id="filter_search"
                    v-on:click="filter = !filter; this.search=''"
                    :class="{ setclose: filter }"
                  >
                    <img src="../../../assets/img/icons/filter.svg" alt="img" />
                    <span
                      ><img src="../../../assets/img/icons/closes.svg" alt="img"
                    /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset"
                    ><img src="../../../assets/img/icons/search-white.svg" alt="img"
                  /></a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        v-model="search"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                        aria-controls="DataTables_Table_0"
                        @change="searching"
                      />
                    </label>
                  </div>
                </div>
              </div>

            </div>
                <div class="table-responsive">
              <a-table
                :columns="columns"
                :data-source="filteredItems"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'purchaseid'">
                    <div class="productimgname">
                      <a href="javascript:void(0);">{{ record.PurchaseItem }}</a>
                    </div>

                    </template>
                  <template v-else-if="column.key === 'action' && ['admin'].includes(userRole)">
                    <a class="me-3" @click="editpurchase(record)" href="javascript:void(0);">
                      <img src="../../../assets/img/icons/edit.svg" alt="img" />
                    </a>
                    <a
                      class="me-3 confirm-text"
                      href="javascript:void(0);"
                      @click="showAlert(record.purchaseid)"
                    >
                      
            
                      <img src="../../../assets/img/icons/delete.svg" alt="img" />
                    </a>
                    </template>                  
                </template>
              </a-table>
            </div>
          </div>
           
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from 'vuex';
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
axios.defaults.headers.common['api-key'] = process.env.VUE_APP_API_KEY;

const columns = [
  {
    sorter: true,
  },
  {
    title: "Item Name",
    dataIndex: "purchaseitem",
    
    sorter: {
      compare: (a, b) => {
        a = a.purchaseitem.toLowerCase();
        b = b.purchaseitem.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Supplier",
    dataIndex: "vendor",
    sorter: {
      compare: (a, b) => {
        a = a.vendor?a.vendor.toLowerCase():'';
        b = b.vendor?b.vendor.toLowerCase():'';
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "ReceivedDate",
    dataIndex: "purchasedate",
    sorter: {
      compare: (a, b) => {
        a = a.purchasedate.toLowerCase();
        b = b.purchasedate.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Invoice Date",
    dataIndex: "invoicedate",
    sorter: {
      compare: (a, b) => {
        a = new Date(a.invoicedate);
        b = new Date(b.invoicedate);
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
    {
    title: "Quantity",
    dataIndex: "quantity",
    sorter: {
      compare: (a, b) => {
        a = a.quantity;
        b = b.quantity;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "UnitPrice",
    dataIndex: "unitprice",
    sorter: {
      compare: (a, b) => {
        a = a.unitprice;
        b = b.unitprice;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "TotalPrice",
    dataIndex: "totalprice",
    sorter: {
      compare: (a, b) => {
        a = a.totalprice;
        b = b.totalprice;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
  
];
export default {
  data() {
    return {
      filter: false,
      search:'',
      title: "PURCHASE LIST",
      title1: "Manage your purchases",
      items: [
        {
          text: "Add New Purchases",
          addname: "/addpurchase",
        },
      ],
      data: null,
      columns,
      startdate: null,
      Choose: ["Choose Supplier", "Supplier"],
      Status: ["Choose Status", "Inprogress"],
      Payment: ["Choose Payment Status", "Payment Status"],
    };
  },
  methods: {
     handleKeydown(event) {

      if (this.$route.path === '/purchaselist' && event.ctrlKey && (event.key === 'm') || event.ctrlKey && (event.key === 'M')) {
        event.preventDefault(); 
        
        this.$router.push('/addpurchase');
      }
    },
    searching() {
      if (this.search) this.filter = true;
    },
    showAlert(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
          .delete('/v1/purchases/'+id)
          .then(response => {
            Swal.fire("Deleted!", "Purchase has been deleted.");
            var index = this.data.findIndex(function(o){
              return o.purchaseid === id;
            })
            if (index !== -1) this.data.splice(index, 1);
          })
          .catch(error => {
            console.log(error)
            Swal.fire(error.response.data.detail);
          });
          
        }
      });
    },
    editpurchase(purchases) {
      this.$router.push({ path: '/editpurchase', query: { id: purchases.purchaseid } });
    },
    async getPurchases() {
      axios
      .get(`/v1/purchases?locationid=${this.locationId}`)
      .then(response => {
        this.data = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    },
  },
  computed: {
    filteredItems() {
      return this.data?this.data.filter(item => {
        return !this.search || 
                item['purchaseitem'].toString().toLowerCase().includes(this.search.toLowerCase());
      }):null;
    },...mapGetters(['getCurrentLocation']),

    currentLocation() { return this.getCurrentLocation; },
    
    locationName() {
      const loc = this.currentLocation;
      return loc ? Object.keys(loc) : null;
    },
    locationId() {
      const loc = this.currentLocation;
      return loc ? loc.id: null;
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  beforeMount() {
    this.getPurchases();
  },
  name: "purchaselist",
};
</script>
<style>
.ant-tooltip {
  display: none !important;
}
</style>
 